import React, { useState } from 'react';

const ViewProfile = ({ user, onClose }) => {
    const [expandedSections, setExpandedSections] = useState({
        basicInfo: true,
        kundali: true
    });

    // Toggle section visibility
    const toggleSection = (section) => {
        setExpandedSections({
            ...expandedSections,
            [section]: !expandedSections[section]
        });
    };

    // Format date if available
    const formatDate = (dateString) => {
        if (!dateString) return "Not available";
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            }).toUpperCase();
        } catch (e) {
            return dateString;
        }
    };

    return (
        <div className="h-full bg-white flex flex-col overflow-y-auto">
            {/* Profile Header - Optional, not in the image */}
            {user?.name && (
                <div className="px-4 py-3 border-b">
                    <div className="flex justify-between items-center">
                        <div className="w-10 h-10 rounded-full bg-[#F15A29] flex items-center justify-center text-white font-semibold text-lg">
                            {user.name?.charAt(0).toUpperCase()}
                        </div>
                        <h2 className="text-lg font-semibold">{user?.name}</h2>
                        {onClose && (
                            <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-100">
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Basic Information Section */}
            <div className="border-b">
                <div
                    className="flex items-center px-4 py-3 cursor-pointer"
                    onClick={() => toggleSection('basicInfo')}
                >
                    <div className="mr-3">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <span className="font-medium">Basic information</span>
                    <div className="ml-auto">
                        <svg
                            className={`h-5 w-5 transition-transform ${expandedSections.basicInfo ? 'transform rotate-180' : ''}`}
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>

                {expandedSections.basicInfo && (
                    <div className="px-4 pb-4 text-sm">
                        <div className="grid grid-cols-3 py-2">
                            <div className="text-gray-500">Date of Birth</div>
                            <div className="col-span-2">
                                <span className="text-orange-500">
                                    {user?.dateOfBirth ? user.dateOfBirth : "Not available"}
                                </span>
                            </div>
                        </div>

                        <div className="grid grid-cols-3 py-2">
                            <div className="text-gray-500">Time of Birth</div>
                            <div className="col-span-2">
                                <span className="text-orange-500">
                                    {user?.timeOfBirth ? user.timeOfBirth : "Not available"}
                                </span>
                            </div>
                        </div>

                        <div className="grid grid-cols-3 py-2">
                            <div className="text-gray-500">Place of Birth</div>
                            <div className="col-span-2">
                                <span className="text-orange-500">
                                    {user?.placeOfBirth ? user.placeOfBirth : "Not available"}
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Generated Kundali Section */}
            <div className="border-b">
                <div
                    className="flex items-center px-4 py-3 cursor-pointer"
                    onClick={() => toggleSection('kundali')}
                >
                    <div className="mr-3">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <span className="font-medium">Generated Kundali</span>
                    <div className="ml-auto">
                        <svg
                            className={`h-5 w-5 transition-transform ${expandedSections.kundali ? 'transform rotate-180' : ''}`}
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>

                {expandedSections.kundali && (
                    <div className="px-4 pb-4">
                        {user?.reports && user.reports.length > 0 ? (
                            user.reports.map((report, index) => (
                                <div key={index} className="mb-4 last:mb-0">
                                    <div className="flex justify-between items-center mb-1">
                                        <div className="text-sm font-medium">{report.title || "Report"}</div>
                                        {report.free !== undefined && report.free &&
                                            <div className="text-green-500 text-xs font-medium">Free</div>
                                        }
                                    </div>
                                    <div className="text-xs text-gray-500 mb-2">
                                        {report.date ?
                                            `${report.date}${report.time ? `, ${report.time}` : ""}` :
                                            "Date not available"
                                        }
                                    </div>
                                    <button
                                        className="w-full bg-orange-500 text-white py-2 rounded-full text-sm font-medium"
                                        onClick={report.onViewPdf || (() => { })}
                                    >
                                        View PDF
                                    </button>
                                </div>
                            ))
                        ) : (
                            <div className="text-center py-3 text-gray-500">No reports available</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ViewProfile;